<template>
  <section class="account--basic">
    <v-container>
      <v-layout column>
        <v-flex sm12>
          <div class="account--header-grid">
            <div class="account--header-col-9">
              <div class="d-flex">
                <v-text-field
                  label="Search Accounts By Name"
                  style="width: 90%;"
                  v-model="opts.name"
                  @keyup.enter="search"
                />
                <div>
                  <v-btn icon color="primary" @click="search">
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div>
              <v-btn outline color="primary" to="/user-accounts/create">
                <v-icon left>add</v-icon>Create New
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider/>
    <section>
      <v-container grid-list-md>
        <v-layout column>
          <v-flex sm12>
            <div class="account--list-grid">
              <div class="account--span-col-4">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="account--text-style">NAME</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div class="account--span-col-3">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="account--text-style">EMAIL</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div class="account--span-col-3">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="account--text-style">COMPANY</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div class="account--span-col-3">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="account--text-style">PHONE</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div>
                <v-list-tile-action>
                  <v-btn icon color="primary" disabled>
                    <v-icon>menu</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <v-divider/>
    <section v-if="loaded">
      <v-container grid-list-md>
        <v-layout column>
          <!-- REPEAT THIS FOR PEOPLE WITH  IMAGE -->
          <v-flex sm12 v-for="user in users.docs" :key="user.id">
            <v-card>
              <div class="account--list-grid">
                <div class="account--span-col-4">
                  <v-list-tile>
                    <v-list-tile-avatar v-if="user.avatar">
                      <img
                        :src="
                    user.avatar ||
                    'https://lh4.googleusercontent.com/-03EW-FpeRBE/AAAAAAAAAAI/AAAAAAAAAAA/ZYNO4RH0oOo/s228-p/photo.jpg'
                    "
                      >
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <router-link :to="`/user-accounts/${user.id}`">{{ user.name || ""}}</router-link>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div class="account--span-col-3">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ user.email || "" }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div class="account--span-col-3">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title style="text-transform: capitalize;">
                        <router-link
                          :to="`/company/${user.company.id}`"
                        >{{ user.company.name || ""}}</router-link>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div class="account--span-col-3">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ user.phone || "NOT FOUND" }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div>
                  <v-list-tile-action>
                    <v-menu bottom left nudge-top="-40">
                      <v-btn slot="activator" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list>
                        <!-- VIEW THE USER -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/user-accounts/${user.id}`">
                              <v-icon>remove_red_eye</v-icon>&nbsp;
                              View
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <!-- UPDATE THE USER -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/user-accounts/${user.id}?update=1`">
                              <v-icon>edit</v-icon>&nbsp;
                              Update
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <!-- DELETE THE USER -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/user-accounts/${user.id}?delete=1`">
                              <v-icon>delete</v-icon>&nbsp;
                              Delete
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action>
                </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex sm12 v-if="(users.docs || []).length < 1">
            <div class="text-xs-center" style="margin: 50px auto;">
              <h2 style="font-size: 40px;">No Users Found!</h2>
            </div>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-pagination :length="users.pages" :total-visible="8" v-model="opts.page"></v-pagination>
        </div>
      </v-container>
    </section>
    <section v-else>
      <Loader/>
    </section>
  </section>
</template>
<script>
import { coreClient } from "../../apollo";
import Loader from "../../components/loader.vue";
import gql from "graphql-tag";
import generateSnackbarError from "../generateSnackbarError";
export default {
  data() {
    return {
      loaded: false,
      users: {},
      opts: {
        name: "",
        page: 1
      }
    };
  },
  components: {
    Loader
  },
  methods: {
    getUsers(variables = {}) {
      const obs = coreClient.watchQuery({
        query: gql`
          query users(
            $name: String
            $company: String
            $page: Int
            $limit: Int
          ) {
            Users(name: $name, company: $company, page: $page, limit: $limit) {
              total
              pages
              page
              docs {
                id
                name
                email
                avatar
                phone
                company {
                  id
                  name
                }
              }
            }
          }
        `,
        variables,
        fetchPolicy: "cache-and-network"
      });
      obs.subscribe(
        ({ data, loading }) => {
          this.loaded = !loading;
          if (data) {
            this.users = data.Users;
          }
        },
        err => {
          this.loaded = true;
          this.$store.commit(
            "updateSnackbar",
            generateSnackbarError(err, "Users")
          );
        }
      );
    },
    search() {
      this.getUsers(this.opts);
    }
  },
  async mounted() {
    this.opts.page = Number(this.$route.query.page) || this.opts.page;

    await this.getUsers(this.opts);

    this.$watch("opts.page", async page => {
      this.$router.push({
        name: "Accounts",
        query: { ...this.$route.query, page: this.opts.page }
      });
      await this.getUsers(this.opts);
    });
    this.$watch("opts.name", async val => {
      if (val === "") {
        await this.getUsers({
          ...this.opts,
          name: val
        });
      }
    });
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/UserAccounts.styl';
</style>
